import openSideIcon from "assets/icons/circle-arrow-left.svg";
import closeSideIcon from "assets/icons/circle-arrow-right.svg";
import logo from "assets/images/Cowva.svg";
import favIcon from "assets/images/cowva-favicon.svg";
import Navlink from "components/navlink";
import { bottomSidebarRoutes, topSidebarRoutes } from "constant";
import { useActiveRoutes, useSidebar, useUser } from "hooks";
import { useEffect, useState } from "react";
import plusIcon from "assets/icons/add-icon.svg";
import minusIcon from "assets/icons/minus-icon.svg";
import userIcon from "assets/icons/user-business.svg";
import familyIcon from "assets/icons/family-inactive.svg";
import { getTokenFromLocalStore } from "utils";
import { IRoutesProps } from "types";

export default function DesktopSidebar() {
  const { isExpanded, toggleSidebar, openSidebar } = useSidebar();
  const { user } = useUser();

  const userRoles: string[] = getTokenFromLocalStore("roles") || [];

  const [openDropdown, setOpenDropdown] = useState<string>("user");
  const [visibleRoutes, setvisibleRoutes] =
    useState<IRoutesProps[]>(topSidebarRoutes);
  const { activeTopRoutes, activeBottomRoutes, activeAefiSidebarRoutes } =
    useActiveRoutes(visibleRoutes, bottomSidebarRoutes, userRoles);

  const [hfRoutes, setHfRoutes] = useState<Record<string, IRoutesProps[]>>(
    activeAefiSidebarRoutes
  );

  const handleDropdownToggle = (role: string) => {
    setOpenDropdown((prev) => (prev === role ? "" : role));
  };

  useEffect(() => {
    if (user?.email) {
      setvisibleRoutes((prevRoutes) =>
        prevRoutes?.map((route) =>
          route.path === "/manage-family-accounts"
            ? { ...route, shouldShow: true }
            : route.path === "/wallet"
            ? { ...route, shouldShow: true }
            : route.path === "/book-appointment"
            ? { ...route, shouldShow: true }
            : route
        )
      );
    }
  }, [user]);

  useEffect(() => {
    const facilityRoles: any[] = getTokenFromLocalStore("facility_roles") || [];
    const updatedRoutes = Object.keys(activeAefiSidebarRoutes).reduce(
      (acc, key) => {
        const matchedFacility = facilityRoles.find(
          (facility) => facility.hfSlug === key
        );

        if (matchedFacility) {
          acc[key] = activeAefiSidebarRoutes[key].map((route) => ({
            ...route,
            shouldShow:
              matchedFacility.hfRole === "hf_owner" ? true : route.shouldShow,
          }));
        }

        return acc;
      },
      {} as Record<string, IRoutesProps[]>
    );

    if (JSON.stringify(updatedRoutes) !== JSON.stringify(hfRoutes)) {
      setHfRoutes(updatedRoutes);
    }
  }, [activeAefiSidebarRoutes, hfRoutes]);

  const renderRoutes = (routes: typeof visibleRoutes) => {
    return routes
      .filter((route) => route.shouldShow)
      .map((route, index) => {
        return (
          <Navlink
            key={index}
            icon={route.icon}
            inactiveIcon={route.inactiveIcon}
            label={route.label}
            path={route.path}
            isActive={route.isActive}
            showLabel={isExpanded}
            hasSubRoute={route.hasSubRoute}
            subRoute={route.subRoute}
          />
        );
      });
  };

  return (
    <div
      className={`h-full border-r border-[#E4E7EC] transition-width duration-300 z-50 relative ${
        isExpanded ? "w-[30%]" : "w-[100px]"
      }`}
      style={{ overflow: "visible" }}
    >
      <div className="w-full h-full flex flex-col px-3 py-5 bg-white z-[100]">
        <div className="flex flex-col gap-5 h-fit">
          <div className="flex justify-between items-center">
            <img src={isExpanded ? logo : favIcon} alt="Logo" />
          </div>
          <div className="h-[30px] flex relative items-center">
            <img
              src={isExpanded ? closeSideIcon : openSideIcon}
              alt="Toggle Sidebar"
              className="absolute right-[-30px] top-1/2 -translate-y-1/2 cursor-pointer"
              onClick={() => {
                toggleSidebar();
                handleDropdownToggle("");
              }}
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-scroll overflow-x-hidden">
          <div className="w-full px-2 flex flex-col gap-1 ">
            {userRoles.length > 1
              ? userRoles.map((role, roleIndex) => (
                  <div key={roleIndex}>
                    <div
                      className={`flex justify-between items-center cursor-pointer pl-4 h-[50px] ${
                        openDropdown === role ? "font-bold" : ""
                      }`}
                      onClick={() => {
                        handleDropdownToggle(role);
                        if (!isExpanded) {
                          openSidebar();
                        }
                      }}
                    >
                      {role === "user" ? (
                        <span className="flex gap-3 items-center">
                          <img src={userIcon} alt="" />
                          {isExpanded && <span>User</span>}
                        </span>
                      ) : (
                        <span className="flex gap-3 items-center">
                          <img src={familyIcon} alt="" />
                          {isExpanded && <span>{role}</span>}
                        </span>
                      )}

                      {isExpanded && (
                        <button>
                          {openDropdown === role ? (
                            <img src={minusIcon} alt="Toggle Icon" />
                          ) : (
                            <img src={plusIcon} alt="Toggle Icon" />
                          )}
                        </button>
                      )}
                    </div>

                    {openDropdown === role && (
                      <div className="pl-4 flex flex-col gap-1  z-50">
                        {role === "user"
                          ? renderRoutes(activeTopRoutes)
                          : renderRoutes(hfRoutes[role] || [])}
                      </div>
                    )}
                  </div>
                ))
              : renderRoutes(
                  userRoles[0] === "user"
                    ? activeTopRoutes
                    : hfRoutes[userRoles[0]] || []
                )}
          </div>
        </div>

        <div className="w-full px-2 flex flex-col gap-1 h-fit">
          {renderRoutes(activeBottomRoutes)}
        </div>
      </div>
    </div>
  );
}
